import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import { authActions } from '../../../core/auth';

class SignIn extends Component {
  state = {
    showMessage: false,
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { message } = nextProps;

    if (message && this.props.message !== message) {
      this.setState({
        showMessage: true,
      });
      setTimeout(() => {
        this.setState({
          showMessage: false,
        });
      }, 3000);
    }
  }

  handleSubmit = this.handleSubmit.bind(this);
  handleSubmit(e) {
    e.preventDefault();
    this.props.signInWithEmail(this.email.value, this.pw.value);
  }

  render() {
    const { showMessage } = this.state;
    const { message } = this.props;

    return (
      <div className="g-row sign-in">
        <div className="g-col">
          <h1 className="sign-in__heading">ログイン</h1>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                className="form-control"
                ref={email => (this.email = email)}
                placeholder="メールアドレスを入力してください"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="パスワードを入力してください"
                ref={pw => (this.pw = pw)}
                autoComplete="off"
              />
            </div>
            <button type="submit" className="btn sign-in__button">
              Login
            </button>
          </form>
        </div>
        <Snackbar open={showMessage} message={message} />
      </div>
    );
  }
}

SignIn.propTypes = {
  message: PropTypes.string,
  signInWithEmail: PropTypes.func.isRequired,
};

//= ====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = state => ({
  message: state.auth.message,
});

export default connect(mapStateToProps, authActions)(SignIn);



// WEBPACK FOOTER //
// ./src/views/pages/sign-in/index.js